import clsx from 'clsx';

/**
 * Design System · ProgressSteps
 * Barra de progresso por etapas (etapa X de N). done = verde, now = azul.
 */

interface ProgressStepsProps {
  total: number;
  /** nº de etapas concluídas. */
  done: number;
  /** índice (0-based) da etapa atual — recebe destaque azul. */
  now?: number;
  className?: string;
}

export function ProgressSteps({ total, done, now, className }: ProgressStepsProps) {
  return (
    <div className={clsx('flex gap-1', className)}>
      {Array.from({ length: total }).map((_, i) => (
        <div
          key={i}
          className={clsx(
            'flex-1 h-1.5 rounded-full',
            i < done ? 'bg-green' : i === now ? 'bg-blue ring-2 ring-blue/25' : 'bg-border',
          )}
        />
      ))}
    </div>
  );
}
